import axios, { AxiosResponse } from 'axios';
import { mutate } from 'swr';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';

import { TLenderUtilityGeneralForm } from './General/validation';
import { TLenderUtilityLoanInfoForm } from './LoanInfo/validation';

export const requestAddLender = async({ ...data }: TLenderUtilityGeneralForm) => {
  const path = `${SERVICES.LENDER}/lenders`;
  let response: AxiosResponse;

  try {
    response = await axios.post(path, data);
    Notistack.successMessage('Lender - Created Successfully');

    mutate(path);

    return mutate(response && `${path}/${response?.data?.id}`, async() => {
      return response?.data || data;
    });
  } catch (error) {
    Notistack.generalError(getError(error));
  }
};

export const requestUpdateGeneral = async({ id, ...data }: TLenderUtilityGeneralForm) => {
  const path = `${SERVICES.LENDER}/lenders/${id}/general`;
  try {
    const resp = await axios.patch(path, data);
    Notistack.successMessage('General - Saved Successfully');
    return resp;
  } catch (error) {
    Notistack.generalError(getError(error));
  }
};

export const requestUpdateAutoSubmitEligible = async(id: string, autoSubmitEligible: boolean) => {
  const path = `${SERVICES.LENDER}/lenders/${id}/autoSubmitEligibility?eligibility=${autoSubmitEligible}`;
  return mutate(`/lender-service/lenders/${id}`, async() => {
    try {
      await axios.patch(path);
      Notistack.successMessage('Auto Submit Eligibility - Saved Successfully');
  
    } catch (error) {
      Notistack.generalError(getError(error));
    }
  });
};

export const requestUpdateLoanInfo = async({ id, ...data }: TLenderUtilityLoanInfoForm) => {
  const path = `${SERVICES.LENDER}/lenders/${id}/general`;
  const payload = {
    ...data,
    openLendingConfiguration: data.isOpenLending ? data.openLendingConfiguration : null,
    meridianConfiguration: data.isMeridian ? data.meridianConfiguration : null,
    cudlConfiguration: data.isOrigence ? data.cudlConfiguration : null,
  };
  try {
    const resp = await axios.patch(path, payload);
    Notistack.successMessage('Loan Info - Saved Successfully');
    return resp;
  } catch (error) {
    Notistack.generalError(getError(error));
  }
};
